module.exports = __webpack_public_path__ + "static/media/brand-name.8ca50096.svg";